import { onLogRecord, type LogRecord } from "./logger";
import type { EventLog } from "./eventLog";

/**
 * Mirrors structured logger records into the EventLog so they survive in the timeline,
 * IndexedDB, and exports. The iframe console is invisible to an operator watching the
 * workspace tab, so console-only logging is how crashes go undiagnosed.
 *
 * Skips `eventLog` namespaced records to break the loop: EventLog itself warns on
 * eviction, which would otherwise append → evict → warn → append.
 */
export function attachLogBridge(eventLog: EventLog): () => void {
  return onLogRecord((record) => {
    if (record.ns === "eventLog") return;
    eventLog.append(toEntry(record));
  });
}

/** Maps a logger record onto the EventLog shape used by the timeline. */
function toEntry(record: LogRecord): Parameters<EventLog["append"]>[0] {
  return {
    kind: "log",
    moduleId: record.ns,
    name: record.message,
    payload: {
      level: record.level,
      ...(record.data !== undefined && { data: record.data }),
    },
  };
}
